import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, Card, Form, Input, Layout, message } from "antd";
import LogoIcon from "../../assets/icons/latest_vivo_logo.svg?react";
import authService from "../../services/authService";
const { Header, Content } = Layout;

const emailRegex = /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [, setEmailSentAgain] = useState(false);

  const showSuccessMsg = () => {
    messageApi.open({
      type: "success",
      content: `We've sent you instructions to ${email}. Please check your inbox.`,
      duration: 8,
    });
  };

  const showErrorMsg = () => {
    messageApi.open({
      type: "error",
      content: `There was an error sending your email. Try again later`,
      duration: 8,
    });
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const onFinishFailed = () => {
    setEmailSent(false);
  };

  const handleResendEmail = async (email: string) => {
    try {
      const success = await authService.forgotPassword(email);

      if (success) {
        showSuccessMsg();
        setEmailSentAgain(true);
      } else {
        showErrorMsg();
      }
    } catch (error) {
      console.error(error);
      setEmailSentAgain(false);
      showErrorMsg();
    }
  };

  const onFinish = async (values: { email: string }) => {
    setEmail(values.email);
    try {
      const success = await authService.forgotPassword(values.email);

      if (success) {
        setEmailSent(true);
      } else {
        showErrorMsg();
      }
    } catch (error) {
      console.error(error);
      setEmailSent(false);
      showErrorMsg();
    }
  };

  return (
    <Layout className="main-auth-container">
      <Header className="header-auth-container">
        <LogoIcon className="mt-[30px]" />
      </Header>
      <Content>
        {contextHolder}
        <div className="flex flex-col justify-center items-center h-screen">
          {emailSent === true ? (
            <Card style={{ width: "530px" }}>
              <p className="text-[24px] font-bold">Check your inbox</p>
              <p className="text-[14px] text-[#556C75] mb-[30px]">
                We&apos;ve sent an email to <span>{email}</span> on resetting
                your password.
              </p>
              <div className="flex justify-between mb-3">
                <Button
                  className="w-36 text-[#064C68] rounded-sm bg-[#D2EFF9] border-[#064C68]"
                  onClick={goToLogin}
                >
                  Back to login
                </Button>
                <Button
                  type="primary"
                  className="w-36 rounded-sm shadow-none"
                  onClick={() => handleResendEmail(email)}
                >
                  Resend email
                </Button>
              </div>
            </Card>
          ) : (
            <Card style={{ width: "530px" }}>
              <p className="text-[24px] font-bold">Forgot your password?</p>
              <p className="text-[14px] text-[#556C75] mb-[30px]">
                We&apos;ll email instructions to you on how to reset it.
              </p>
              <Form
                name="basic"
                style={{
                  maxWidth: 850,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email.",
                      pattern: emailRegex,
                    },
                    {
                      required: true,
                      message: "Please input your email.",
                    },
                  ]}
                >
                  <Input size="large" allowClear placeholder="Email" />
                </Form.Item>
                <Form.Item className="text-center max-w-(--breakpoint-lg) px-8 mb-0">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="w-36 mt-2 rounded-sm shadow-none"
                  >
                    Send email
                  </Button>
                </Form.Item>
              </Form>
              <div className="flex flex-col items-center">
                <p className="flex flex-col items-center text-[40px] text-[#D5DADC]">
                  |
                </p>
                <p className="mb-2 font-medium">Changed your mind?</p>
                <Button
                  className="w-36 text-[#064C68] rounded-sm bg-[#D2EFF9] border-[#064C68]"
                  onClick={goToLogin}
                >
                  Return to log in
                </Button>
              </div>
            </Card>
          )}
        </div>
      </Content>
    </Layout>
  );
}
